import React from "react";

/**
 * Generates an ApproveIcon component with the given class.
 *
 * @param {string} cls - optional class name for the icon
 * @return {JSX.Element} the ApproveIcon component
 */
export const ApproveIcon = ({ cls = "" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="Table Nav Buttons Icons">
        <path
          id="Check_Mark"
          d="M12 22.3516C6.48609 22.3516 2 17.8655 2 12.3516C2 6.83766 6.48609 2.35156 12 2.35156C17.5139 2.35156 22 6.83766 22 12.3516C22 17.8655 17.5139 22.3516 12 22.3516ZM12 3.60156C7.17516 3.60156 3.25 7.52672 3.25 12.3516C3.25 17.1764 7.17516 21.1016 12 21.1016C16.8248 21.1016 20.75 17.1764 20.75 12.3516C20.75 7.52672 16.8248 3.60156 12 3.60156ZM10.5669 15.9184L16.8169 9.66844C17.0611 9.42422 17.0611 9.02875 16.8169 8.78469C16.5727 8.54063 16.1772 8.54047 15.9331 8.78469L10.125 14.5928L8.06687 12.5347C7.82266 12.2905 7.42719 12.2905 7.18313 12.5347C6.93906 12.7789 6.93891 13.1744 7.18313 13.4184L9.68313 15.9184C9.80516 16.0405 9.96516 16.1016 10.125 16.1016C10.2848 16.1016 10.4448 16.0405 10.5669 15.9184Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
